import { Typography } from "@material-ui/core"
import { CarExtraItemDtoDelekComponent } from "api"
import { formatPrice } from "common/price"
import Strikethrough from "common/Strikethrough"
import { KeyboardEvent } from "react"
import CheckBoxIcon from "reusable/formsComp/checkbox/CheckBoxIcon"
import CheckBoxSelectedIcon from "reusable/formsComp/checkbox/CheckBoxSelectedIcon"
import styled from "styled-components"
import colors from "theme/colors"

const StyledContainer = styled.div`
  cursor: pointer;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  background-color: ${(p) => p.theme.colors.white};
`
const StyledImageWrap = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: ${(83 * 100) / 160}%;
  position: relative;
`
const StyledImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`
const StyledDetailsWrap = styled.div`
  padding: 15px 10px;
  text-align: center;
`
const StyledDiscount = styled.div`
  font-size: 0.75rem;
  line-height: 1;

  color: ${colors.disable};
  margin-bottom: 5px;
`
const StyledPrice = styled.div`
  font-size: 0.875rem;
`
const StyledActualPrice = styled.span``
const StyledDiscountPrice = styled.span`
  color: ${(p) => p.theme.colors.mazdaRed};
  display: inline-block;
  margin-left: 0.5em;
  ~ ${StyledActualPrice} {
    color: ${(p) => p.theme.colors.disable};
  }
`
const StyledName = styled.div`
  font-size: 1rem;
  margin-bottom: 10px;
`
const StyledDescription = styled.div`
  font-size: 0.75rem;
  color: ${(p) => p.theme.palette.text.primary};
`

const StyledCheckboxWrap = styled.div<{ $hide?: boolean }>`
  position: absolute;
  top: 10px;
  right: 10px;
  opacity: ${(p) => (p.$hide ? 0 : 1)};
  visibility: ${(p) => (p.$hide ? "hidden" : "visible")};
  transition: all 0.3s ease-in-out;
`

type AccessoryProps = {
  accessory: CarExtraItemDtoDelekComponent
  isSelected: boolean
  onSelect: () => void
}

const Accessory = ({ accessory, isSelected, onSelect }: AccessoryProps) => {
  const onEnter = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      onSelect()
    }
  }
  return (
    <StyledContainer
      tabIndex={0}
      role="checkbox"
      aria-checked={isSelected}
      onClick={onSelect}
      onKeyPress={onEnter}
    >
      <StyledImageWrap>
        <StyledImage
          src={accessory.details.image?.imageUrl}
          alt={accessory.details.name}
        />
      </StyledImageWrap>

      <StyledDetailsWrap>
        <StyledPrice>
          {accessory.price.discount > 0 && (
            <>
              <Typography variant="srOnly">מחיר קודם</Typography>
              <StyledDiscountPrice aria-label="מחיר קודם">
                <Strikethrough>
                  {formatPrice(accessory.price.originalPrice)}
                </Strikethrough>
              </StyledDiscountPrice>
            </>
          )}
          <Typography variant="srOnly">מחיר נוכחי</Typography>
          <StyledActualPrice aria-label="מחיר נוכחי">
            {formatPrice(accessory.price.totalPrice)}
          </StyledActualPrice>
          {accessory.price.discount > 0 && (
            <StyledDiscount>הטבת רכישה אונליין</StyledDiscount>
          )}
        </StyledPrice>
        <StyledName>{accessory.details.name}</StyledName>
        <StyledDescription>{accessory.details.description}</StyledDescription>
      </StyledDetailsWrap>
      <StyledCheckboxWrap>
        <CheckBoxIcon />
      </StyledCheckboxWrap>

      {/* <StyledOverlay $isDiscount={accessory.price.discount > 0}></StyledOverlay> */}
      <StyledCheckboxWrap $hide={!isSelected}>
        <CheckBoxSelectedIcon />
      </StyledCheckboxWrap>
    </StyledContainer>
  )
}

export default Accessory
